import { isPlatformServer } from "@angular/common";
import { Component, Inject, PLATFORM_ID } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector:'app-toll-free',
    templateUrl:'./toll-free.component.html',
    styleUrls:['./toll-free.component.scss']
})
export class TollFreeComponent {
    constructor(
        private matDialogRef:MatDialogRef<TollFreeComponent>,
        @Inject(MAT_DIALOG_DATA) public data:any,
            @Inject(PLATFORM_ID) private platformId: string,
    ) {
        this.matDialogRef.addPanelClass('toll-free-dialog');
        // localStorage.setItem('toll-free-opened', 'true');

        if (isPlatformServer(this.platformId)) {
          return;
        }
        localStorage.setItem('toll-free-timestamp-landing', data?.timeStamp);
    }

    closeDialog() {
        this.matDialogRef.close();
    }
}